import { useMemo } from 'react';

import { useTranslateFn } from '../Translate';

import { hydrateWithTranslations } from '@services/TranslatorService';
import type { Match } from '@shared-types/match.types';
import { MatchStatus } from '@shared-types/match.types';

const labelMap = {
  [MatchStatus.UPCOMING]: 'upcoming_match',
  [MatchStatus.LIVE]: 'livescores',
  [MatchStatus.FINISHED]: 'highlights',
} as const;

export const useCtaAriaLabel = (match: Match) => {
  const t = useTranslateFn();
  return useMemo(() => {
    const ctaAriaLabel = labelMap[match.status] && t(labelMap[match.status]);
    const homeTeam = hydrateWithTranslations(match.homeTeam)?.displayName;
    const awayTeam = hydrateWithTranslations(match.awayTeam)?.displayName;
    return [ctaAriaLabel, homeTeam, awayTeam].filter(Boolean).join(' - ');
  }, [match.homeTeam, match.awayTeam, match.status, t]);
};
